var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header_wrap" }, [
      _c(
        "div",
        { staticStyle: { width: "60%" } },
        [
          _c(
            "el-steps",
            {
              staticStyle: { width: "100%" },
              attrs: { "align-center": "", active: 2 }
            },
            [
              _c("el-step", { attrs: { title: "海运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "增值服务" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: "托运信息" } }),
              _vm._v(" "),
              _c("el-step", { attrs: { title: _vm.$t("i18n_confirm_order") } }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: _vm.$t("i18n_order_completed") }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "center_wrap" },
      [
        _c("div", { staticClass: "wrap_l" }, [
          _c("div", {
            staticStyle: { display: "-webkit-flex", "align-items": "center" }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "Item_list" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": _vm.labelPosition,
                        "label-width": "70px"
                      }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系人" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerContact,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerContact",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerContact"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "联系电话" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.customerTel,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "customerTel",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.customerTel"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "委托公司" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.namec,
                                  callback: function($$v) {
                                    _vm.$set(_vm.Authorization, "namec", $$v)
                                  },
                                  expression: "Authorization.namec"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "业务员" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: _vm.Authorization.salesName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.Authorization,
                                      "salesName",
                                      $$v
                                    )
                                  },
                                  expression: "Authorization.salesName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.todoordate
                        ? _c(
                            "el-col",
                            { attrs: { span: 10 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { label: "提货时间" } },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      type: "date",
                                      format: "yyyy-MM-dd",
                                      "value-format": "yyyy-MM-dd",
                                      disabled: "",
                                      placeholder: "选择日期",
                                      "picker-options": _vm.pickerOptions
                                    },
                                    model: {
                                      value: _vm.todoordate,
                                      callback: function($$v) {
                                        _vm.todoordate = $$v
                                      },
                                      expression: "todoordate"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "入仓时间" } },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  type: "date",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                  placeholder: "选择日期",
                                  "picker-options": _vm.pickerSetTime
                                },
                                model: {
                                  value: _vm.inwarehousetime,
                                  callback: function($$v) {
                                    _vm.inwarehousetime = $$v
                                  },
                                  expression: "inwarehousetime"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.countLIst_T.name != "",
                  expression: "countLIst_T.name != ''"
                }
              ],
              staticClass: "Item_list"
            },
            [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    width: "100%",
                    "padding-left": "30px",
                    "box-sizing": "border-box"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.countLIst_T.name,
                          expression: "countLIst_T.name"
                        }
                      ],
                      staticClass: "thatpoperWrap",
                      staticStyle: { "margin-top": "20px" }
                    },
                    [
                      _c("div", { staticClass: "popWrap_l" }, [
                        _c("p", { staticClass: "lianxiren" }, [
                          _vm._v(_vm._s(_vm.countLIst_T.name))
                        ]),
                        _vm._v(" "),
                        _c("p", { staticStyle: { "margin-left": "12px" } }, [
                          _vm._v(_vm._s(_vm.countLIst_T.tel))
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "overText",
                            staticStyle: { "margin-left": "20px" }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.countLIst_T.parvince) +
                                _vm._s(_vm.countLIst_T.city) +
                                _vm._s(_vm.countLIst_T.area) +
                                _vm._s(_vm.countLIst_T.address) +
                                "\n              "
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-collapse-transition", [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showTi,
                            expression: "showTi"
                          }
                        ]
                      },
                      _vm._l(_vm.TipopList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "poperWrap",
                            staticStyle: { "margin-top": "20px" },
                            on: {
                              click: function($event) {
                                return _vm.changeTiitem(item)
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "popWrap_l" }, [
                              _c("p", { staticClass: "lianxiren" }, [
                                _vm._v(_vm._s(item.name))
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                { staticStyle: { "margin-left": "12px" } },
                                [_vm._v(_vm._s(item.tel))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "overText",
                                  staticStyle: { "margin-left": "20px" }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(item.parvince) +
                                      _vm._s(item.city) +
                                      _vm._s(item.area) +
                                      _vm._s(item.address) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "popWrap_R" },
                              [
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.isdefault,
                                        expression: "item.isdefault"
                                      }
                                    ],
                                    staticClass: "morentype"
                                  },
                                  [_vm._v("默认地址")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: !item.isdefault,
                                        expression: "!item.isdefault"
                                      }
                                    ],
                                    staticStyle: { color: "#604aff" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.changeshowType(
                                          2,
                                          item,
                                          "ajax"
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("设为默认地址")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "#604aff" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.UpItem(2, item)
                                      }
                                    }
                                  },
                                  [_vm._v("修改")]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _c(
              "div",
              {
                staticClass: "LR_center",
                staticStyle: {
                  display: "-webkit-flex",
                  "align-items": "center"
                }
              },
              [
                _vm._m(2),
                _vm._v(" "),
                !_vm.PSFmoney.checked
                  ? _c(
                      "span",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#604aff" },
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.addNewpop(3)
                              }
                            }
                          },
                          [_vm._v("新增收货人")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "padding-left": "30px",
                  "box-sizing": "border-box"
                }
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.countLIst_C.name == "",
                        expression: "countLIst_C.name == ''"
                      }
                    ],
                    staticClass: "poperWrap"
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("i18n_No_default_contact")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.countLIst_C.name,
                        expression: "countLIst_C.name"
                      }
                    ],
                    staticClass: "thatpoperWrap",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _c("div", { staticClass: "popWrap_l" }, [
                      _c("p", { staticClass: "lianxiren" }, [
                        _vm._v(_vm._s(_vm.countLIst_C.name))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticStyle: { "margin-left": "12px" } }, [
                        _vm._v(_vm._s(_vm.countLIst_C.tel))
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "overText",
                          staticStyle: { "margin-left": "20px" }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.countLIst_C.country) +
                              _vm._s(_vm.countLIst_C.city) +
                              _vm._s(_vm.countLIst_C.area) +
                              _vm._s(_vm.countLIst_C.address) +
                              "\n              "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "popWrap_R" })
                  ]
                ),
                _vm._v(" "),
                _c("el-collapse-transition", [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showSh,
                          expression: "showSh"
                        }
                      ]
                    },
                    _vm._l(_vm.SHpopList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "poperWrap",
                          staticStyle: { "margin-top": "20px" },
                          on: {
                            click: function($event) {
                              return _vm.changeShitem(item)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(item.name))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(item.tel))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "overText",
                                staticStyle: { "margin-left": "20px" }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.country) +
                                    _vm._s(item.city) +
                                    _vm._s(item.area) +
                                    _vm._s(item.address) +
                                    "\n                  "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "popWrap_R" },
                            [
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.isdefault,
                                      expression: "item.isdefault"
                                    }
                                  ],
                                  staticClass: "morentype"
                                },
                                [_vm._v("默认地址")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !item.isdefault,
                                      expression: "!item.isdefault"
                                    }
                                  ],
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.changeshowType(3, item, "ajax")
                                    }
                                  }
                                },
                                [_vm._v("设为默认地址")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#604aff" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.UpItem(3, item)
                                    }
                                  }
                                },
                                [_vm._v("修改")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.SHpopList.length > 1 && !_vm.PSFmoney.checked,
                    expression: "SHpopList.length > 1 && !PSFmoney.checked"
                  }
                ],
                staticStyle: { margin: "10px 0 0 30px" }
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#9a9a9a" },
                    attrs: { type: "text" },
                    on: {
                      click: function($event) {
                        return _vm.openmo3()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.showSh ? "收起更多" : "更多收货人信息"))]
                ),
                _c("span", {
                  class: _vm.showSh ? "el-icon-arrow-up" : "el-icon-arrow-down"
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          !_vm.tuoCheData.checked
            ? _c(
                "div",
                { staticClass: "Item_list", staticStyle: { padding: "0" } },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { width: "100%", "box-sizing": "border-box" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "thatpoperWrap",
                          staticStyle: {
                            padding: "30px 50px",
                            border: "none",
                            background: "#ffffff"
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(_vm.cangkuitem.namec))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(_vm.cangkuitem.tel))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.cangkuitem.country) +
                                    _vm._s(_vm.cangkuitem.addressc) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.PSFmoney.checked
            ? _c(
                "div",
                { staticClass: "Item_list", staticStyle: { padding: "0" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "LR_center",
                      staticStyle: {
                        display: "-webkit-flex",
                        "align-items": "center"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            width: "100%",
                            background: "#ffe9c7",
                            padding: "8px 30px"
                          }
                        },
                        [
                          _c(
                            "p",
                            {
                              staticClass: "tittype",
                              staticStyle: {
                                padding: "0 5px",
                                color: "#c19822",
                                "font-size": "16px"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "i18n_pickup_cargo_at_below_warehouse"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: { width: "100%", "box-sizing": "border-box" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "thatpoperWrap",
                          staticStyle: {
                            padding: "30px 50px",
                            border: "none",
                            background: "#ffffff"
                          }
                        },
                        [
                          _c("div", { staticClass: "popWrap_l" }, [
                            _c("p", { staticClass: "lianxiren" }, [
                              _vm._v(_vm._s(_vm.description.namec))
                            ]),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "12px" } },
                              [_vm._v(_vm._s(_vm.description.tel))]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "20px" } },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.description.addressc) +
                                    "\n              "
                                )
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "Item_list" }, [
            _vm._m(4),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "padding-left": "30px",
                  "box-sizing": "border-box"
                }
              },
              [
                _c("div", { staticStyle: { "margin-top": "20px" } }, [
                  _c(
                    "div",
                    { staticClass: "popWrap_l" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "form",
                          staticStyle: { width: "100%" },
                          attrs: { "label-width": "80px" }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "发货备注" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "100%" },
                                model: {
                                  value: _vm.delgoodsremarks,
                                  callback: function($$v) {
                                    _vm.delgoodsremarks = $$v
                                  },
                                  expression: "delgoodsremarks"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            { attrs: { label: "收货备注" } },
                            [
                              _c("el-input", {
                                model: {
                                  value: _vm.recgoodremarks,
                                  callback: function($$v) {
                                    _vm.recgoodremarks = $$v
                                  },
                                  expression: "recgoodremarks"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.tuoCheData.checked
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "提货备注" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.getgoodsremarks,
                                      callback: function($$v) {
                                        _vm.getgoodsremarks = $$v
                                      },
                                      expression: "getgoodsremarks"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap_R", class: _vm.auto_fixed ? "auto_fixed" : "" },
          [
            _c(
              "p",
              {
                staticStyle: {
                  "font-size": "16px",
                  "font-family": "PingFang SC",
                  "font-weight": "500",
                  color: "#343434"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("i18n_cost_calculation")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "OrderDetails" }, [
              _c(
                "div",
                {
                  staticClass:
                    "Item_Right animate__animated animate__bounceInRight"
                },
                [
                  _c("p", { staticClass: "tit" }, [_vm._v("海运费")]),
                  _vm._v(" "),
                  _vm._l(_vm.HYFmoney.goodsTypeFeeDTOS, function(item, index) {
                    return _c("p", { key: index, staticClass: "coutText" }, [
                      _c("span", { staticClass: "littit" }, [
                        _vm._v(_vm._s(item.goodsTypeName))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "fontString" }, [
                        _vm._v(_vm._s(item.currency) + _vm._s(item.amount))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("(" + _vm._s(item.calDesc) + ")")
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v(_vm._s(_vm.$t("i18n_subtotal")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        _vm._s(_vm.HYFmoney.currency) +
                          _vm._s(_vm.HYFmoney.amount)
                      )
                    ])
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tuoCheData.checked,
                      expression: "tuoCheData.checked"
                    }
                  ],
                  staticClass:
                    "Item_Right animate__animated animate__bounceInRight"
                },
                [
                  _c("p", { staticClass: "tit" }, [
                    _vm._v("提货费"),
                    _vm.tuoCheData.minKilometer
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "13px",
                              float: "right",
                              "font-weight": "500"
                            }
                          },
                          [
                            _vm._v(
                              "(" +
                                _vm._s(_vm.tuoCheData.minKilometer + "KM") +
                                "--" +
                                _vm._s(_vm.tuoCheData.maxKilometer + "KM") +
                                ")"
                            )
                          ]
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v("发货地上门提货")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        _vm._s(_vm.tuoCheData.currency) +
                          _vm._s(_vm.tuoCheData.amount)
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.PSFmoney.checked,
                      expression: "PSFmoney.checked"
                    }
                  ],
                  staticClass:
                    "Item_Right animate__animated animate__bounceInRight"
                },
                [
                  _c("p", { staticClass: "tit" }, [_vm._v("配送费")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "coutText" }, [
                    _c("span", { staticClass: "littit" }, [
                      _vm._v("目的地送货上门")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "fontString" }, [
                      _vm._v(
                        _vm._s(_vm.PSFmoney.currency) +
                          _vm._s(_vm.PSFmoney.amount)
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "Item_Right" },
                [
                  _c("p", { staticClass: "tit" }, [_vm._v("增值服务费")]),
                  _vm._v(" "),
                  _vm._l(_vm.formData, function(item, index) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: item.checked,
                            expression: "item.checked"
                          }
                        ],
                        key: index,
                        staticClass:
                          "coutText animate__animated animate__bounceInRight"
                      },
                      [
                        _c("span", { staticClass: "littit" }, [
                          _vm._v(_vm._s(item.feeName))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "fontString" }, [
                          _vm._v(
                            _vm._s(item.currency) +
                              _vm._s(item.amount) +
                              "\n              "
                          ),
                          item.feeCode == "CLEF"
                            ? _c("span", [
                                _vm._v(
                                  "(" +
                                    _vm._s(item.basePrice) +
                                    "+" +
                                    _vm._s(item.cnycontinuationPrice) +
                                    "*" +
                                    _vm._s(item.piece)
                                )
                              ])
                            : _c("span", [
                                _vm._v(
                                  "(" +
                                    _vm._s(item.piece) +
                                    "*" +
                                    _vm._s(item.price)
                                )
                              ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.feeUnit,
                                  expression: "item.feeUnit"
                                }
                              ],
                              staticClass: "fontString"
                            },
                            [_vm._v(_vm._s(item.feeUnit))]
                          ),
                          _vm._v(")")
                        ])
                      ]
                    )
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "Item_Right" }, [
                _c(
                  "p",
                  { staticClass: "coutText" },
                  [
                    _c("span", { staticClass: "littit" }, [_vm._v("合计费用")]),
                    _vm._v(" "),
                    _vm._l(this.newArray, function(item, index) {
                      return _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.amount > 0,
                              expression: "item.amount > 0"
                            }
                          ],
                          key: index,
                          staticClass: "fontString"
                        },
                        [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.currency != "",
                                  expression: "item.currency != ''"
                                }
                              ]
                            },
                            [_vm._v(_vm._s(item.currency))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.amount > 0,
                                  expression: "item.amount > 0"
                                }
                              ],
                              staticClass: "fontString",
                              staticStyle: {
                                "margin-left": "5px",
                                "margin-right": "5px"
                              }
                            },
                            [_vm._v(_vm._s(item.amount))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    index == _vm.newArray.length - 1
                                      ? false
                                      : true,
                                  expression:
                                    "index == newArray.length - 1 ? false : true"
                                }
                              ]
                            },
                            [_vm._v("+")]
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("p", { staticClass: "coutText" }, [
                  _c("span", { staticClass: "littit" }, [_vm._v("折合人民币")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "fontString" }, [
                    _vm._v("CNY " + _vm._s(_vm.calculatePrice))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  width: "100%",
                  "margin-top": "30px",
                  float: "left"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        on: {
                          click: function($event) {
                            return _vm.pathToback()
                          }
                        }
                      },
                      [_vm._v("上一步")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { width: "100%", "margin-top": "10px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          width: "100%",
                          background: "#604aff",
                          color: "#ffffff"
                        },
                        on: {
                          click: function($event) {
                            return _vm.pathToNext()
                          }
                        }
                      },
                      [_vm._v("下一步")]
                    )
                  ],
                  1
                )
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            staticClass: "dialog",
            attrs: {
              width: _vm.width,
              visible: _vm.dialogTableVisible,
              closeOnClickModal: false
            },
            on: {
              "update:visible": function($event) {
                _vm.dialogTableVisible = $event
              }
            }
          },
          [
            _c("div", { staticClass: "wrap_count" }, [
              _c("div", { staticClass: "header_logo" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(!this.itemid ? "新增地址" : "修改地址") +
                    "\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "count" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-position": _vm.labelPosition,
                        "label-width": "80px"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系人" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入姓名" },
                            model: {
                              value: _vm.fromPop.name,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "name", $$v)
                              },
                              expression: "fromPop.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "联系方式" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入联系方式" },
                            model: {
                              value: _vm.fromPop.tel,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "tel", $$v)
                              },
                              expression: "fromPop.tel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.changeNum == 2,
                              expression: "changeNum == 2"
                            }
                          ],
                          attrs: { label: "联系地址" }
                        },
                        [
                          _c("el-cascader", {
                            ref: "refSsqname",
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.Guojialist,
                              props: _vm.defaultParams
                            },
                            on: { change: _vm.changessq },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var node = ref.node
                                  var data = ref.data
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.namec))]),
                                    _vm._v(" "),
                                    !node.isLeaf ? _c("span") : _vm._e()
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.ssqnames,
                              callback: function($$v) {
                                _vm.ssqnames = $$v
                              },
                              expression: "ssqnames"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.changeNum == 3,
                              expression: "changeNum == 3"
                            }
                          ],
                          attrs: { label: "联系地址" }
                        },
                        [
                          _c("el-cascader", {
                            ref: "refSsqname",
                            staticStyle: { width: "100%" },
                            attrs: {
                              options: _vm.citylist,
                              props: _vm.defaultParams
                            },
                            on: { change: _vm.changessq },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function(ref) {
                                  var node = ref.node
                                  var data = ref.data
                                  return [
                                    _c("span", [_vm._v(_vm._s(data.namec))]),
                                    _vm._v(" "),
                                    !node.isLeaf ? _c("span") : _vm._e()
                                  ]
                                }
                              }
                            ]),
                            model: {
                              value: _vm.ssqnames,
                              callback: function($$v) {
                                _vm.ssqnames = $$v
                              },
                              expression: "ssqnames"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.changeNum != 1,
                              expression: "changeNum != 1"
                            }
                          ]
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入详细地址",
                              type: "textarea"
                            },
                            model: {
                              value: _vm.fromPop.address,
                              callback: function($$v) {
                                _vm.$set(_vm.fromPop, "address", $$v)
                              },
                              expression: "fromPop.address"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "type" } },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value: _vm.fromPop.isdefault,
                                callback: function($$v) {
                                  _vm.$set(_vm.fromPop, "isdefault", $$v)
                                },
                                expression: "fromPop.isdefault"
                              }
                            },
                            [
                              _c("el-checkbox", { attrs: { name: "type" } }, [
                                _vm._v("设置为默认地址")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onSubmit }
                            },
                            [_vm._v(_vm._s(_vm.itemid ? "修改" : "确定新增"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.dialogTableVisible = false
                                }
                              }
                            },
                            [_vm._v("取消")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "-webkit-flex",
          "align-items": "center",
          "margin-bottom": "20px"
        }
      },
      [
        _c("img", {
          attrs: { src: require("../../assets/weituo.png"), alt: "" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "tittype" }, [_vm._v("委托信息")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "LR_center",
        staticStyle: { display: "-webkit-flex", "align-items": "center" }
      },
      [
        _c("div", { staticClass: "count_center" }, [
          _c("img", {
            attrs: { src: require("../../assets/tihuo.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "tittype", staticStyle: { color: "#333" } }, [
            _vm._v("提货信息")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "count_center" }, [
      _c("img", {
        attrs: { src: require("../../assets/shouhuo.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "tittype" }, [_vm._v("收货信息")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "LR_center",
        staticStyle: { display: "-webkit-flex", "align-items": "center" }
      },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "100%",
              background: "#ffe9c7",
              padding: "8px 30px"
            }
          },
          [
            _c(
              "p",
              {
                staticClass: "tittype",
                staticStyle: {
                  padding: "0 5px",
                  color: "#c19822",
                  "font-size": "16px"
                }
              },
              [_vm._v("\n              请将货物送至以下仓库\n            ")]
            )
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "LR_center",
        staticStyle: { display: "-webkit-flex", "align-items": "center" }
      },
      [
        _c("div", { staticClass: "count_center" }, [
          _c("img", {
            attrs: { src: require("../../assets/ps.png"), alt: "" }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "tittype" }, [_vm._v("备注")])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-981bfff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-981bfff6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/placeOrder/Consignment.vue
// module id = null
// module chunks = 